import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  code: '',
  loading: false,
  error: '',
  errorDescription: '',
  totalRegistros: 0
}

// getters
const getters = {
}

// actions
const actions = {
  async typeRappel ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let codcomV = ''
      if (params.codcom !== undefined) {
        codcomV = params.codcom
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codestrap: codcomV,
            tipoestrap: params.tipoestrap
          }
        }
      })
      const response = await HTTP.post(config.endpoints.listTypeRappel, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  async numRappel ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile

    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let numrappelR = ''
      if (params.numrappel !== undefined) {
        numrappelR = params.numrappel
      }
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: '',
            claveInicio: '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: '',
            oficina: '',
            pantPagina: '',
            retroceder: false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            numrappel: numrappelR
          }
        }
      })
      const response = await HTTP.post(config.endpoints.numTypeRappel, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            if (Array.isArray(response.data.runServiceResponse.return.registros)) return response.data.runServiceResponse.return.registros
            else return [response.data.runServiceResponse.return.registros]

          case 210:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'TYPE_RAPPEL_REQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'TYPE_RAPPEL_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'TYPE_RAPPEL_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.totalRegistros = datos.totalRegistros
    state.code = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
  },
  'TYPE_RAPPEL_REQUEST_FAILED' (state, payload) {
    if (payload.retorno === 200) {
      state.errorDescription = 'Error de ejecución para los criterios de selección'
    }
    state.error = true
    state.code = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
